import { useQuery } from '@tanstack/react-query';

import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';
import AuditTable from '~/pages/AuditHistory/AuditTable';

import Layout from './Layout';

export default function QueueManagerAuditHistory() {
  const {
    obfuscatedLoanIdentifier: {
      obfuscatedLenderDatabaseId,
      obfuscatedLoanRecordId,
    },
  } = useUrl();

  const { isLoading, isError, data } = useQuery({
    queryKey: ['auditHistory', 'queueManagerAudit'],
    async queryFn() {
      const response = await typedApiClient.v1.queueQueueAuditList(
        obfuscatedLenderDatabaseId,
        obfuscatedLoanRecordId,
      );
      return response.data;
    },
    select(data) {
      return Object.entries(data)
        .filter(([, value]) => value.length)
        .map(([key, value]) => ({
          key,
          value: value.map((item) => ({
            fieldValue: item.action,
            userName: item.user,
            userEmail: item.email,
            modifiedDateTime: item.dateTime,
          })),
        }));
    },
  });

  return (
    <Layout
      pageEnum="queue-manager"
      isLoading={isLoading}
      isError={isError}
      isDataEmpty={data?.length === 0}
    >
      <AuditTable
        data={data}
        headers={{
          loanAction: 'Queue',
          response: 'Loan Action',
        }}
        section={{}}
      />
    </Layout>
  );
}
